import { useBooleanState } from "~/common/hooks/useBooleanState";
import ToastMessage from "~/common/components/Messages/ToastMessage/ToastMessage";
import { Trans } from "react-i18next";
import { useEffect } from "react";
import { restorePreviousAccount, type PreviousAccountRollback } from "./restorePreviousAccount";

export const AccountErrorMessage = ({ previousAccount }: { previousAccount: PreviousAccountRollback }) => {
  const { val, setTrue, setFalse } = useBooleanState(false);

  useEffect(() => {
    setTrue();
  }, []);

  return (
    <>
      {val && (
        <ToastMessage type={"info"} onClose={() => setFalse()}>
          <span className={"scha__quote-details__toast-account"}>
            <Trans i18nKey={"notification.toast.redirectPreviousAccount"}>
              <b>Please note</b> that you have been redirected to a quote belonging to a different account.{" "}
              <a
                href={previousAccount.redirectUrl}
                onClick={(event) => {
                  event.preventDefault();
                  void restorePreviousAccount(previousAccount);
                }}
              >
                Go back to previous account
              </a>
            </Trans>
          </span>
        </ToastMessage>
      )}
    </>
  );
};
